<template>
  <div class="parking-redemption-page">
    <main class="content-wrapper">
      <h1 class="page-title">{{ $t("message.ParkingRedemption") }}</h1>

      <section class="redemption-panel">
        <v-tabs
          v-model="model"
          class="redemption-tabs"
          centered
          grow
          hide-slider
        >
          <v-tab @click="ChangeTab('Search')">{{
            $t("message.Search")
          }}</v-tab>
          <v-tab @click="ChangeTab('QR')">{{
            $t("message.ScanQRCode")
          }}</v-tab>
          <v-tab-item>
            <v-card flat class="tab-content">
              <v-card-text class="search-content">
                <div class="search-field-wrapper">
                  <v-text-field
                    class="search-input"
                    :placeholder="$t('message.InputPlaceholder')"
                    outlined
                    hide-details
                    v-model="SearchInput"
                    @keyup.enter="SearchParking"
                  ></v-text-field>
                </div>
                <div class="search-action">
                  <v-btn
                    class="search-button"
                    depressed
                    :loading="LoadingDialog"
                    @click="SearchParking()"
                  >
                    {{ $t("message.Search") }}
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat class="tab-content">
              <v-card-text class="qr-content">
                <div class="qr-reader">
                  <qrcode-stream
                    v-if="Status && scanning"
                    :constraints="qrConstraints"
                    :track="drawScanBox"
                    @decode="onDecode"
                    @init="onInit"
                  />
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </section>
    </main>

    <v-dialog v-model="UpdateLicensePlateDialog" persistent width="400">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="CloseUpdateLicensePlateDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12" align="center">
              <p style="font-size: 20px; color: black">กรุณาระบุทะเบียนรถ</p>
              <v-text-field
                placeholder="LicensePlate"
                label="License Plate"
                type="text"
                outlined
                v-model="LicensePlate"
                :maxlength="8"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" align="center">
              <v-btn
                width="200"
                color="green"
                class="rounded-lg white--text"
                @click="updateLicensePlate()"
                x-large
                >Submit</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="UpdateLicensePlateDialogFromScan" persistent width="400">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="CloseUpdateLicensePlateDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12" align="center">
              <p style="font-size: 20px; color: black">กรุณาระบุทะเบียนรถ</p>
              <v-text-field
                placeholder="LicensePlate"
                label="License Plate"
                type="text"
                outlined
                v-model="LicensePlate"
                :maxlength="8"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" align="center">
              <v-btn
                width="200"
                color="green"
                class="rounded-lg white--text"
                @click="updateLicensePlateFromScan()"
                x-large
                >Submit</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>

    <AlertComponent
      :flagAlert="AlertDialog"
      :typeAlert="TypeAlert"
      :mesAlert="MessageAlert"
      @flagClose="ClearDataAlert()"
    />
  </div>
</template>
<script>
import axios from "axios";
// import { StreamBarcodeReader } from "vue-barcode-reader";
import enurl from "@/api/environment";
import AlertComponent from "@/components/Alert";
// import LoadingComponent from "@/components/Loading";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { QrcodeStream } from "vue-qrcode-reader";
export default {
  name: "Main",
  components: {
    AlertComponent,
    // StreamBarcodeReader,
    // LoadingComponent,
    QrcodeStream,
  },
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      AlertDialog: false,
      TypeAlert: null,
      MessageAlert: "",
      model: 0,
      SearchInput: "",
      QRCodeData: "",
      id: null,
      destroy: false,
      Status: false,
      response: "",
      ColorTab: "#126496",
      ColorText: "#126496",
      ColorText2: "",
      UpdateLicensePlateDialog: false,
      UpdateLicensePlateDialogFromScan: false,
      LicensePlate: "",
      RateList: [],

      scanning: true,
      scanningLock: false,
      qrConstraints: {
        video: {
          facingMode: { ideal: "environment" },
          width: { ideal: 1920 },
          height: { ideal: 1080 },
        },
      },

      projectID: localStorage.getItem("ProjectSiteID"),
    };
  },
  computed: {
    headersSummary() {
      return [
        {
          text: "RateCode",
          align: "left",
        },
        {
          text: "Detail",
          align: "left",
        },
        {
          text: "Remaining",
          align: "left",
        },
      ];
    },
  },
  watch: {},

  methods: {
    drawScanBox(ctx, frame) {
      const { width, height } = frame;
      const size = Math.min(width, height) * 0.65;
      const x = (width - size) / 2;
      const y = (height - size) / 2;
      ctx.clearRect(0, 0, width, height);
      ctx.strokeStyle = "#00FF99";
      ctx.lineWidth = 4;
      ctx.strokeRect(x, y, size, size);
    },

    async onDecode(temp) {
      if (this.scanningLock) {
        return;
      }
      this.scanningLock = true;
      this.scanning = false;
      this.QRCodeData = temp;
      await this.SearchParkingByQRCode(temp);
    },

    async onInit(promise) {
      try {
        await promise;
      } catch (e) {
        this.Status = false;
        this.scanning = false;
        this.scanningLock = false;

        Swal.fire({
          icon: "error",
          title: "Camera Error",
          width: 600,
          text: "ไม่สามารถเปิดกล้องได้ (เช็ค permission หรือ https)",
        });
      }
    },

    resumeScan() {
      this.scanning = true;
      this.scanningLock = false;
    },

    ChangeTab(value) {
      let self = this;
      if (value == "Search") {
        self.ColorTab = "#126496";
        self.ColorText = "#126496";
        self.Status = false;
      } else if (value == "QR") {
        self.ColorTab = "orange";
        self.Status = true;
        self.scanning = true;
        self.scanningLock = false;
      } else if (value == "Summary") {
        self.ColorTab = "#eb3636";
        self.ColorText = "#126496";
        self.Status = false;
      }
    },

    CloseTab() {
      window.close();
    },

    ClearDataAlert() {
      let self = this;
      self.AlertDialog = false;
      self.TypeAlert = "";
      self.MessageAlert = "";
    },

    async SearchParkingByQRCode(data) {
      let self = this;
      self.LoadingDialog = true;
      self.QRCodeData = data;
      let temp = {
        LogCarparkID: data,
        LostCard: false,
        projectID: self.projectID
      };
      await axios
        .post(`${self.url}Redemption/GetParkingDetailByQRCode`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.response = response.data.data;
            if (response.data.data.length > 0) {
              var LicensePlate = response.data.data[0].plateNo.replace(" ", "");
              if (
                LicensePlate.includes("000") ||
                LicensePlate.includes("unknown")
              ) {
                self.UpdateLicensePlateDialogFromScan = true;
              } else {
                self.$router.push({
                  name: "ParkingInformation",
                  params: { response: self.response, LogID: self.LogCarparkID },
                });
              }
            }
          } else {
            Swal.fire({
              icon: "error",
              width: 900,
              text: response.data.message,
            });
          }
        })
        .catch(function (error) {
          let message = "เกิดข้อผิดพลาด";
          if (error.response && error.response.data) {
            message = error.response.data.message || message;
          }
          Swal.fire({
            icon: "error",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
          self.resumeScan();
        });
    },

    CloseUpdateLicensePlateDialog() {
      this.LicensePlate = "";
      this.UpdateLicensePlateDialog = false;
      this.UpdateLicensePlateDialogFromScan = false;

      this.scanning = true;
      this.scanningLock = false;
    },

    updateLicensePlate() {
      let self = this;
      if (self.LicensePlate == "" || self.LicensePlate == null) {
        Swal.fire({
          icon: "warning",
          width: 900,
          text: "กรุณากรอกเลขทะเบียน !",
        });
        return;
      }
      if (
        self.LicensePlate.includes("000") ||
        self.LicensePlate.includes("unknown")
      ) {
        Swal.fire({
          icon: "warning",
          width: 900,
          text: "กรุณากรอกเลขทะเบียน !",
        });
        return;
      } else {
        var LastArrayData = "";
        if (self.QRCodeData != "") {
          var dataArray = self.QRCodeData.split("/");
          LastArrayData = dataArray[dataArray.length - 1];
        }

        let temp = {
          license: self.LicensePlate,
          logCarpark: self.SearchInput == "" ? LastArrayData : self.SearchInput,
          projectID: parseInt(self.projectID)
        };

        axios
          .post(`${self.url}Redemption/updateLicensePlate`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              var logCarpark =
                self.SearchInput == "" ? LastArrayData : self.SearchInput;
              self.CloseUpdateLicensePlateDialog();
              self.SearchParkingByQRCode(logCarpark);
            }
            self.LoadingDialog = false;
          })
          .catch(function (error) {
            let message = "เกิดข้อผิดพลาด";
            if (error.response && error.response.data) {
              message = error.response.data.message || message;
            }
            Swal.fire({
              icon: "error",
              width: 900,
              text: message,
            });
          });
      }
    },

    updateLicensePlateFromScan() {
      let self = this;
      if (self.LicensePlate == "" || self.LicensePlate == null) {
        Swal.fire({
          icon: "warning",
          width: 900,
          text: "กรุณากรอกเลขทะเบียน !",
        });
        return;
      }
      if (
        self.LicensePlate.includes("000") ||
        self.LicensePlate.includes("unknown")
      ) {
        Swal.fire({
          icon: "warning",
          width: 900,
          text: "กรุณากรอกเลขทะเบียน !",
        });
        return;
      } else {
        var dataArray = self.QRCodeData.split("/");
        var LastArrayData = dataArray[dataArray.length - 1];

        let temp = {
          license: self.LicensePlate,
          logCarpark: LastArrayData,
          projectID: self.projectID
        };
        axios
          .post(`${self.url}Redemption/updateLicensePlate`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              self.CloseUpdateLicensePlateDialog();
              self.SearchParkingByQRCode(LastArrayData);
            }
            self.LoadingDialog = false;
          })
          .catch(function (error) {
            let message = "เกิดข้อผิดพลาด";
            if (error.response && error.response.data) {
              message = error.response.data.message || message;
            }
            Swal.fire({
              icon: "error",
              width: 900,
              text: message,
            });
          });
      }
    },

    SearchParking() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.SearchInput,
        LostCard: false,
        projectID: self.projectID
      };
      axios
        .post(`${self.url}Redemption/GetParkingDetail`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.response = response.data.data;
            if (response.data.data.length > 0) {
              var LicensePlate = response.data.data[0].plateNo.replace(" ", "");
              if (
                LicensePlate.includes("000") ||
                LicensePlate.includes("unknown")
              ) {
                self.UpdateLicensePlateDialog = true;
              } else {
                self.$router.push({
                  name: "ParkingInformation",
                  params: { response: self.response, LogID: self.LogCarparkID },
                });
              }
            }
          } else {
            Swal.fire({
              icon: "warning",
              width: 900,
              text: response.data.message,
            });
          }
        })
        .catch(function (error) {
          let message = "เกิดข้อผิดพลาด";
          if (error.response && error.response.data) {
            message = error.response.data.message || message;
          }
          Swal.fire({
            icon: "error",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    GetDataRateCodeSummary() {
      let self = this;
      axios
        .get(`${self.url}Redemption/GetDataRateCodeSummary`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.RateList = response.data.data;
          }
        })
        .catch(function (error) {
          let message = "เกิดข้อผิดพลาด";
          if (error.response && error.response.data) {
            message = error.response.data.message || message;
          }
          Swal.fire({
            icon: "error",
            width: 900,
            text: message,
          });
        });
    },
  },
};
</script>
<style scoped>
.parking-redemption-page {
  min-height: calc(90vh - 64px);
  background: #ffffff;
  color: #262223;
}

.content-wrapper {
  width: min(100% - 48px, 1164px);
  margin: 0 auto;
  padding: 88px 0 96px;
}

.page-title {
  margin: 0;
  color: #262223;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 35px;
  font-weight: 400;
  line-height: 1.15;
  letter-spacing: 0.02em;
  text-align: center;
  text-wrap: balance;
}

.redemption-panel {
  margin-top: 162px;
}

.redemption-tabs {
  background: transparent !important;
}

.redemption-tabs >>> .v-tabs-bar {
  height: 55px;
  background: transparent !important;
  border-bottom: 1px solid #969292;
}

.redemption-tabs >>> .v-slide-group__content {
  justify-content: center;
}

.redemption-tabs >>> .v-tab {
  position: relative;
  flex: 0 0 auto;
  min-width: auto;
  max-width: none;
  height: 55px;
  padding: 0 23px;
  color: #262223 !important;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 25px;
  font-weight: 400;
  letter-spacing: 0.01em;
  text-transform: uppercase;
}

.redemption-tabs >>> .v-tab::before {
  display: none;
}

.redemption-tabs >>> .v-tab--active::after {
  position: absolute;
  right: 20px;
  bottom: -1px;
  left: 20px;
  height: 6px;
  background: #262223;
  content: "";
}

.tab-content {
  background: transparent !important;
}

.search-content {
  padding: 73px 0 0 !important;
}

.search-field-wrapper {
  width: 100%;
}

.search-input >>> .v-input__slot {
  min-height: 82px;
  margin: 0;
  padding: 0 31px !important;
  background: #ffffff !important;
  border-radius: 14px !important;
  box-shadow: 0 7px 8px rgba(38, 34, 35, 0.24);
}

.search-input >>> fieldset {
  border: 1px solid #262223 !important;
}

.search-input >>> input {
  color: #262223;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 20px;
  line-height: 1.4;
}

.search-input >>> input::placeholder {
  color: #6b6768;
  opacity: 1;
}

.search-input >>> .v-input__slot:hover fieldset,
.search-input >>> .v-input--is-focused fieldset {
  border-color: #262223 !important;
}

.search-action {
  display: flex;
  justify-content: center;
  margin-top: 83px;
}

.search-button {
  min-width: 165px !important;
  height: 45px !important;
  padding: 0 38px !important;
  border-radius: 999px !important;
  background: #262223 !important;
  box-shadow: 0 8px 8px rgba(38, 34, 35, 0.3) !important;
  color: #ffffff !important;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 19px !important;
  font-weight: 400 !important;
  letter-spacing: 0.01em !important;
}

.search-button:hover,
.search-button:focus-visible {
  background: #403a3c !important;
}

.qr-content {
  display: flex;
  justify-content: center;
  padding: 73px 0 0 !important;
}

.qr-reader {
  width: min(100%, 560px);
  overflow: hidden;
  border-radius: 14px;
}

.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);

  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}
.centered-input-header >>> input {
  text-align: center;
  color: black;
}
* >>> .v-data-table-header {
  background-color: #333333 !important;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}
.addUserTitle {
  font-size: 14px;
  font-weight: 300;
}
.input-border {
  border: 1px solid black;
  height: 35px;
  padding: 4px;
}
.validation-class {
  color: red;
  font-size: 12px;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.parking-card {
  display: block;
  background-color: #fff;
  padding: 0 1rem;
}

@font-face {
  font-family: "Mrs Eaves Lining OT";
  src: url("~@/assets/Font/Lining.otf") format("opentype");
  font-style: normal;
  font-weight: 400;
  font-display: swap;
}

@media (max-width: 959px) {
  .content-wrapper {
    width: min(100% - 40px, 760px);
    padding-top: 64px;
  }

  .redemption-panel {
    margin-top: 112px;
  }

  .search-content,
  .qr-content {
    padding-top: 52px !important;
  }
}

@media (max-width: 600px) {
  .parking-redemption-page {
    min-height: calc(100vh - 56px);
  }

  .content-wrapper {
    width: calc(100% - 32px);
    padding: 48px 0 72px;
  }

  .page-title {
    font-size: 34px;
  }

  .redemption-panel {
    margin-top: 76px;
  }

  .redemption-tabs >>> .v-tabs-bar,
  .redemption-tabs >>> .v-tab {
    height: 49px;
  }

  .redemption-tabs >>> .v-tab {
    padding: 0 12px;
    font-size: 21px;
  }

  .redemption-tabs >>> .v-tab--active::after {
    right: 10px;
    left: 10px;
    height: 4px;
  }

  .search-content,
  .qr-content {
    padding-top: 40px !important;
  }

  .search-input >>> .v-input__slot {
    min-height: 82px;
    padding: 0 20px !important;
    border-radius: 12px !important;
  }

  .search-input >>> input {
    font-size: 20px;
  }

  .search-action {
    margin-top: 52px;
  }

  .search-button {
    min-width: 180px !important;
    height: 54px !important;
    font-size: 17px !important;
  }
}

@media (prefers-reduced-motion: reduce) {
  .search-button {
    transition: none !important;
  }
}
/* .qr-scan-wrapper {
  width: 100%;
  max-width: 360px;
  aspect-ratio: 1 / 1;
  margin: auto;
  position: relative;
}

.qr-scan-wrapper video {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
  border-radius: 12px;
} */
</style>
